import React from "react";
import { Container, Box, makeStyles, Grid, Divider,useMediaQuery,useTheme } from "@material-ui/core";
import Logo from "../assets/images/logo.PNG";
import { useHistory } from "react-router-dom";
import SlideDownModal from "../components/reusableComponents/SlideDownModal";
import Footer from "./Desktop/Footer";
import SearchEngine from "../form/SearchEngine";
import TransactionHistory from "../components/reusableComponents/TransactionHistory";
import HeaderSection from "../components/reusableComponents/HeaderSection";
const useStyles = makeStyles(() => ({
  item: {
    //   backgroundColor: "#ee8622",
    display: "flex",
    listStyle: "none",
    marginBottom: 0,
    marginTop: 0,
    "&:hover": {
      backgroundColor: "#ee8622",
    },
  },
  li: {
    color: "white",
    padding: "4px 8px",
    background: "no-repeat",
    borderRight: "none",
  },
  card: {
    padding: 30,
    background: "rgba(62, 29, 28, 0.9)",
    "&:hover": {
      // backgroundColor: "#ee8622",
      boxShadow: "rgb(149 157 165 / 20%) 0px 8px 24px",
    },
  },
}));
const BankDetail = () => {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = React.useState(false);
  const [header, SetHeader] = React.useState("onlineRecharge");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handelHeader = (val) => {
    SetHeader(val);
  };
  return (
    <div>
    <HeaderSection/>
      <Divider style={{ background: "#0f3f5a" }} />
      <Container style={{ paddingLeft: matches?10:50, paddingRight:  matches?10:50, paddingTop: 50 }}>
        <p
          style={{
            textAlign: "center",
            color: "rgb(15, 63, 90)",
            fontSize: 30,
            fontWeight: "bold",
          }}
        >
          Bank Details
        </p>

        <Grid container style={{ marginTop: 30 }} spacing={2}>
          <Grid item xs={12} lg={3}></Grid>
          <Grid item xs={12} lg={3}>
            <Box
              style={{
                boxShadow: "0 5px 15px rgba(0,0,0,.1)",
                padding: 20,
                borderLeft: "1px solid #52ee22!important",
              }}
            >
              <span style={{ color: "#000", fontSize: 24, fontWeight: "bold" }}>
                ABC BANK
              </span>
              <Box>
                <span>Branch: ABC Branch</span>
                <br></br>
                <span>Account Number: ABC Branch</span>
                <br></br>
                <span>Account Holder: ABC</span>
                <br></br>
                <span>IFSC Code: BJUI654</span>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} lg={3}>
            <Box
              style={{ boxShadow: "0 5px 15px rgba(0,0,0,.1)", padding: 20,borderRight:'1px solid #52ee22!important' }}
            >
              <span style={{ color: "#000", fontSize: 24, fontWeight: "bold" }}>
                ABC BANK
              </span>
              <Box>
                <span>Branch: ABC Branch</span>
                <br></br>
                <span>Account Number: ABC Branch</span>
                <br></br>
                <span>Account Holder: ABC</span>
                <br></br>
                <span>IFSC Code: BJUI654</span>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} lg={3}></Grid>
        </Grid>
      </Container>
      <Footer />
    </div>
  );
};

export default BankDetail;
